'use client';

import { Divider, VStack } from '@chakra-ui/react';

import { isZmyleTransactionIntent } from 'utils/helpers';
import { GiftcardTransactionItem } from './GiftcardTransactionItem';
import { GiftcardTransactionsContainer } from './GiftcardTransactionsContainer';

interface Props {
  transactions: Paginated<
    AdaptedGiftcardTransaction | AdaptedGiftcardTransactionIntent
  >;
  content: GiftcardTransactionsListContent;
  onLoadMore?(): Promise<void>;
}

export type GiftcardTransactionsListProps = Props;

export const GiftcardTransactionsList = (props: Props) => {
  const { transactions, content, onLoadMore } = props;

  return (
    <GiftcardTransactionsContainer
      onLoadMore={onLoadMore}
      transactions={transactions}
    >
      <VStack divider={<Divider />} w="full" pt="0.75rem">
        {transactions?.items.map(transaction => (
          <GiftcardTransactionItem
            key={
              isZmyleTransactionIntent(transaction)
                ? transaction.transactionIntentId
                : transaction.id
            }
            transaction={transaction}
            content={content}
          />
        ))}
      </VStack>
    </GiftcardTransactionsContainer>
  );
};
